var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2712_10454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47594 2.2168L0.589469 3.74877C0.540031 3.77467 0.493344 3.80417 0.449219 3.83645L7.83019 7.6853L10.921 6.15655L3.47594 2.2168Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9973 4.69141L12.3047 6.51778V8.57538C12.3047 8.83416 12.0949 9.04397 11.8361 9.04397C11.5773 9.04397 11.3675 8.83416 11.3675 8.57538V6.98134L8.29297 8.50206V15.9488C8.30259 15.9443 8.31234 15.9402 8.32187 15.9354L15.3901 12.354C15.7656 12.1663 15.9987 11.789 15.9987 11.3691V4.73281C15.9987 4.71891 15.9978 4.70519 15.9973 4.69141Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3925 3.74768L8.3272 0.167771L8.32427 0.166303C8.00967 0.00967759 7.63586 0.0131776 7.3242 0.175678L4.47852 1.68596L11.9588 5.64437L15.5695 3.85852C15.5146 3.81677 15.4558 3.7793 15.3925 3.74768Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00221875 4.66016C0.00096875 4.68162 0 4.70313 0 4.72481V11.3773C0 11.7887 0.22625 12.1623 0.5905 12.353L7.32003 15.9246L7.32306 15.9262C7.33425 15.9321 7.34569 15.9372 7.35703 15.9426V8.49534L0.00221875 4.66016Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2712_10454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.d2cb496e08532e5641f403b460b95efd.svg";
export { ForwardRef as ReactComponent };